import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';
import { Constants } from '../constants';

const Pagination = ({ pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext;
  return (
    <nav id="page-nav" className="clearfix">
      {previousPagePath && (
        <Link className="prev" to={previousPagePath}>
          <span className="icon icon-chevron-left" />
          <span className="text">Previous</span>
        </Link>
      )}
      {nextPagePath && (
        <Link className="next" to={nextPagePath}>
          <span className="text">Next</span>
          <span className="icon icon-chevron-right" />
        </Link>
      )}
    </nav>
  );
};

Pagination.propTypes = {
  constants: PropTypes.object,
  pageContext: PropTypes.object,
};

Pagination.defaultProps = {
  constants: Constants,
};

export default Pagination;
